import {
  Box,
  Text,
  SimpleGrid,
  Radio,
  RadioGroup,
  Button,
  FormLabel,
  VStack,
  Flex,
  Stack,
  HStack,
  Collapse,
} from "@chakra-ui/react";
import { useRecoilState } from "recoil";
import { createCampaignAtom } from "../../../atoms/campaigns";
import FormInput from "../../UI/form/FormInput";
import { VisualBuilderIcon, TextBuilderIcon } from "../../../icons/Builder";

const GettingStarted = () => {
  const options = [
    {
      name: "SMS",
      description: "Send a campaign to reach out to all your SMS contacts.",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill="#159D6F" fillOpacity="0.04" />
          <path
            d="M11.9999 19.2067C11.5399 19.2067 11.1066 18.9734 10.7999 18.5667L9.79992 17.2334C9.77992 17.2067 9.69992 17.1734 9.66659 17.1667H9.33325C6.55325 17.1667 4.83325 16.4134 4.83325 12.6667V9.33337C4.83325 6.38671 6.38659 4.83337 9.33325 4.83337H14.6666C17.6133 4.83337 19.1666 6.38671 19.1666 9.33337V12.6667C19.1666 15.6134 17.6133 17.1667 14.6666 17.1667H14.3333C14.2799 17.1667 14.2333 17.1934 14.1999 17.2334L13.1999 18.5667C12.8933 18.9734 12.4599 19.2067 11.9999 19.2067ZM9.33325 5.83337C6.94659 5.83337 5.83325 6.94671 5.83325 9.33337V12.6667C5.83325 15.68 6.86659 16.1667 9.33325 16.1667H9.66659C10.0066 16.1667 10.3933 16.36 10.5999 16.6334L11.5999 17.9667C11.8333 18.2734 12.1666 18.2734 12.3999 17.9667L13.3999 16.6334C13.6199 16.34 13.9666 16.1667 14.3333 16.1667H14.6666C17.0533 16.1667 18.1666 15.0534 18.1666 12.6667V9.33337C18.1666 6.94671 17.0533 5.83337 14.6666 5.83337H9.33325Z"
            fill="#159D6F"
          />
          <path
            d="M15.3334 9.83337H8.66675C8.39341 9.83337 8.16675 9.60671 8.16675 9.33337C8.16675 9.06004 8.39341 8.83337 8.66675 8.83337H15.3334C15.6067 8.83337 15.8334 9.06004 15.8334 9.33337C15.8334 9.60671 15.6067 9.83337 15.3334 9.83337Z"
            fill="#159D6F"
          />
          <path
            d="M12.6667 13.1666H8.66675C8.39341 13.1666 8.16675 12.94 8.16675 12.6666C8.16675 12.3933 8.39341 12.1666 8.66675 12.1666H12.6667C12.9401 12.1666 13.1667 12.3933 13.1667 12.6666C13.1667 12.94 12.9401 13.1666 12.6667 13.1666Z"
            fill="#159D6F"
          />
        </svg>
      ),
      available: true,
    },
    {
      name: "Email",
      description: "Send a campaign to reach out to all your Email contacts.",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill="#0066FF" fillOpacity="0.04" />
          <path
            d="M15.334 18.1654H8.66732C6.23398 18.1654 4.83398 16.7654 4.83398 14.332V9.66536C4.83398 7.23203 6.23398 5.83203 8.66732 5.83203H15.334C17.7673 5.83203 19.1673 7.23203 19.1673 9.66536V14.332C19.1673 16.7654 17.7673 18.1654 15.334 18.1654ZM8.66732 6.83203C6.76065 6.83203 5.83398 7.7587 5.83398 9.66536V14.332C5.83398 16.2387 6.76065 17.1654 8.66732 17.1654H15.334C17.2407 17.1654 18.1673 16.2387 18.1673 14.332V9.66536C18.1673 7.7587 17.2407 6.83203 15.334 6.83203H8.66732Z"
            fill="#0066FF"
          />
          <path
            d="M11.9992 12.58C11.4392 12.58 10.8725 12.4066 10.4392 12.0533L8.35253 10.3866C8.1392 10.2133 8.0992 9.89998 8.27254 9.68665C8.44587 9.47331 8.75921 9.43332 8.97254 9.60665L11.0592 11.2733C11.5659 11.68 12.4259 11.68 12.9325 11.2733L15.0192 9.60665C15.2325 9.43332 15.5525 9.46665 15.7192 9.68665C15.8925 9.89998 15.8592 10.22 15.6392 10.3866L13.5525 12.0533C13.1259 12.4066 12.5592 12.58 11.9992 12.58Z"
            fill="#0066FF"
          />
        </svg>
      ),
      available: false,
    },
    // {
    //   name: "Whatsapp",
    //   description:
    //     "Send a campaign to reach out to all your Whatsapp contacts.",
    //   icon: (
    //     <svg
    //       width="24"
    //       height="24"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <circle cx="12" cy="12" r="12" fill="#159D6F" fillOpacity="0.05" />
    //       <path
    //         d="M5.33343 19.1642C5.20009 19.1642 5.07341 19.1109 4.98007 19.0176C4.85341 18.8909 4.80011 18.7042 4.84677 18.5309L5.68678 15.3909C5.12678 14.3509 4.83343 13.1776 4.83343 11.9909C4.83343 8.03755 8.04676 4.82422 12.0001 4.82422C15.9534 4.82422 19.1668 8.03755 19.1668 11.9909C19.1668 15.9442 15.9534 19.1576 12.0001 19.1576C10.7934 19.1576 9.61344 18.8576 8.56011 18.2842L5.46677 19.1442C5.4201 19.1576 5.38009 19.1642 5.33343 19.1642ZM8.62676 17.2509C8.71343 17.2509 8.8001 17.2776 8.8801 17.3176C9.8201 17.8709 10.9001 18.1642 12.0001 18.1642C15.4001 18.1642 18.1668 15.3976 18.1668 11.9976C18.1668 8.59756 15.4001 5.83089 12.0001 5.83089C8.60009 5.83089 5.83343 8.59756 5.83343 11.9976C5.83343 13.0842 6.12009 14.1442 6.66009 15.0776C6.72675 15.1909 6.74676 15.3309 6.71343 15.4576L6.04676 17.9509L8.50009 17.2709C8.54009 17.2576 8.58676 17.2509 8.62676 17.2509Z"
    //         fill="#159D6F"
    //       />
    //       <path
    //         d="M13.8268 15.8415C13.4135 15.8415 12.9868 15.7482 12.5402 15.5548C12.1202 15.3748 11.7002 15.1348 11.2935 14.8348C10.8935 14.5415 10.5002 14.2082 10.1402 13.8482C9.78018 13.4815 9.44682 13.0948 9.15348 12.6948C8.85348 12.2748 8.61348 11.8615 8.44014 11.4548C8.25348 11.0148 8.16016 10.5815 8.16016 10.1682C8.16016 9.87483 8.21348 9.59483 8.31348 9.33483C8.42014 9.06149 8.59348 8.81482 8.82015 8.60149C9.24682 8.18149 9.86018 8.02817 10.3468 8.2615C10.5135 8.33484 10.6535 8.45484 10.7602 8.61484L11.5335 9.70148C11.6135 9.80815 11.6735 9.92148 11.7202 10.0348C11.7735 10.1682 11.8068 10.3015 11.8068 10.4282C11.8068 10.6015 11.7602 10.7748 11.6668 10.9282C11.6068 11.0282 11.5202 11.1482 11.4068 11.2615L11.3201 11.3548C11.3601 11.4082 11.4068 11.4748 11.4801 11.5548C11.6201 11.7148 11.7735 11.8882 11.9401 12.0548C12.1068 12.2148 12.2735 12.3748 12.4401 12.5148C12.5201 12.5815 12.5868 12.6348 12.6402 12.6682L12.7335 12.5748C12.8535 12.4548 12.9735 12.3615 13.0935 12.3015C13.3135 12.1615 13.6535 12.1282 13.9535 12.2548C14.0602 12.2948 14.1668 12.3548 14.2802 12.4348L15.3935 13.2215C15.5468 13.3282 15.6668 13.4748 15.7468 13.6415C15.8135 13.8082 15.8402 13.9548 15.8402 14.1082C15.8402 14.3082 15.7935 14.5015 15.7068 14.6882C15.6202 14.8615 15.5201 15.0148 15.4001 15.1548C15.1868 15.3882 14.9402 15.5615 14.6735 15.6748C14.4068 15.7882 14.1202 15.8415 13.8268 15.8415ZM9.86015 9.16149C9.82015 9.16149 9.68685 9.16149 9.52018 9.32815C9.39352 9.44815 9.30683 9.57483 9.24683 9.71483C9.18683 9.85483 9.16016 10.0148 9.16016 10.1748C9.16016 10.4548 9.22681 10.7548 9.36015 11.0748C9.50015 11.4081 9.70683 11.7615 9.96016 12.1148C10.2202 12.4682 10.5135 12.8215 10.8402 13.1482C11.1668 13.4682 11.5135 13.7682 11.8735 14.0348C12.2202 14.2882 12.5735 14.4882 12.9268 14.6415C13.4335 14.8615 13.9002 14.9148 14.2802 14.7548C14.4135 14.7015 14.5335 14.6082 14.6535 14.4882C14.7135 14.4215 14.7602 14.3548 14.8002 14.2682C14.8202 14.2215 14.8335 14.1682 14.8335 14.1215C14.8335 14.1082 14.8335 14.0882 14.8135 14.0482L13.7002 13.2748C13.6535 13.2415 13.6068 13.2148 13.5668 13.2015C13.5401 13.2148 13.5002 13.2348 13.4268 13.3082L13.1735 13.5615C12.9802 13.7548 12.6735 13.8082 12.4268 13.7215L12.3068 13.6682C12.1535 13.5882 11.9802 13.4682 11.7868 13.3015C11.6002 13.1415 11.4202 12.9748 11.2268 12.7882C11.0402 12.5948 10.8735 12.4148 10.7135 12.2282C10.5402 12.0215 10.4202 11.8548 10.3402 11.7148L10.2668 11.5415C10.2468 11.4748 10.2402 11.4015 10.2402 11.3348C10.2402 11.1482 10.3068 10.9815 10.4335 10.8482L10.6868 10.5882C10.7602 10.5148 10.7868 10.4748 10.8002 10.4482C10.7802 10.4015 10.7535 10.3615 10.7202 10.3148L9.94014 9.21483L9.86015 9.16149Z"
    //         fill="#159D6F"
    //       />
    //     </svg>
    //   ),
    //   available: false,
    // },
  ];

  const [currentStageData, setCurrentStageData] =
    useRecoilState(createCampaignAtom);

  // console.log("cuurrrr", currentStageData);

  return (
    <Box w="full" maxW={"480px"} mx="auto">
      <Box maxWidth="375px">
        <Text fontSize={"20px"} fontWeight={700} color="grays.8">
          Getting Started
        </Text>
        <Text color={"grays.12"} fontWeight={500} fontSize="xs" mt="6px">
          Start with our competitive pay-as-you-go pricing. For deeper discounts
        </Text>
      </Box>

      <Box mt="20px">
        <VStack spacing="16px" align={"flex-start"} w="full">
          <Text fontSize={12} fontWeight={700}>Campaign Name <Text color={'red'} display={'inline'}>*</Text></Text>
          <FormInput
            type="text"
            // label="Campaign name" 
            for="Campaign name"
            inputProps={{
              placeholder: "What would your like to name your campaign?",
              value: currentStageData?.data?.campaign_name,
              onChange: (e) => {
                setCurrentStageData((prevValue) => {
                  return {
                    ...prevValue,
                    data: {
                      ...prevValue.data,
                      campaign_name: e.target.value,
                    },
                  };
                });
              },
            }}
          />

          <Box>
            <FormLabel
              fontWeight={"bold"}
              fontSize="sm"
              color="grays.9"
              htmlFor="Choose channel"
              mb="4px"
              display="flex"
            >
              Choose channel
            </FormLabel>

            <SimpleGrid
              columns={2}
              // gap="24px"
              borderWidth={"1px"}
              borderRadius="4px"
              borderColor={"borders.100"}
              p="12px"
            >
              {options?.map((option) => {
                return (
                  <Flex
                    key={option?.name}
                    // pb="12px"
                    // borderBottom={option?.name !== "Whatsapp" ? "1px" : ""}
                    // borderColor="borders.100"
                    borderRight={option?.name === "SMS" ? "1px" : ""}
                    borderColor="borders.100"
                    pr={option?.name === "SMS" ? "16px" : "0px"}
                    pl={option?.name === "Email" ? "16px" : "0px"}
                  >
                    <Box mr="5px" width={"100%"}>
                      <HStack spacing={"4px"}>
                        {option?.icon}
                        <RadioGroup
                          width={"100%"}
                          onChange={(e) => {
                            setCurrentStageData((prevData) => {
                              return {
                                ...prevData,
                                data: {
                                  ...prevData?.data,
                                  channel: e,
                                  builder:
                                    e === "SMS"
                                      ? ""
                                      : currentStageData?.data.builder,
                                  message_body:
                                    e === "SMS"
                                      ? ""
                                      : currentStageData?.data.message_body,
                                },
                              };
                            });
                          }}
                          value={
                            // currentStageData?.data?.channel === "sms"
                            //   ? "SMS"
                            //   : currentStageData?.data?.channel === "whatsapp"
                            //   ? "Whatsapp"
                            //   : currentStageData?.data?.channel
                            currentStageData?.data?.channel
                          }
                        >
                          <Stack
                            width={"100%"}
                            spacing={5}
                            direction="row"
                            justifyContent={"space-between"}
                          >
                            <Text fontSize={"sm"}>{option?.name}</Text>
                            <Radio
                              size="lg"
                              colorScheme={"primary"}
                              isDisabled={!option?.available}
                              value={option?.name}
                            />
                          </Stack>
                        </RadioGroup>
                      </HStack>
                      <Text
                        mt="2px"
                        fontSize={"10px"}
                        color="grays.12"
                        fontWeight={500}
                      >
                        {option?.description}
                      </Text>
                    </Box>
                  </Flex>
                );
              })}
            </SimpleGrid>
          </Box>

          <Collapse in={currentStageData?.data?.channel === "Email"}>
            <FormLabel
              fontWeight={"bold"}
              fontSize="sm"
              color="grays.9"
              htmlFor="Choose Builder Type"
              mb="4px"
            >
              Choose Builder Type
            </FormLabel>
            <SimpleGrid columns={1}>
              <RadioGroup
                onChange={(e) => {
                  setCurrentStageData((prevData) => {
                    return {
                      ...prevData,
                      data: {
                        ...prevData?.data,
                        builder: e,
                      },
                    };
                  });
                }}
                value={currentStageData?.data?.builder}
              >
                <HStack>
                  <Box
                    position={"relative"}
                    borderWidth={"1px"}
                    w="190px"
                    h="159px"
                    borderRadius="4px"
                    gap="24px"
                    mr={0}
                    p="12px"
                    borderColor={"borders.100"}
                    
                  >
                    <Radio
                      colorScheme={"primary"}
                      // isDisabled={true}
                      value="visual_builder"
                      position={"absolute"}
                      top={4}
                      right={4}
                      zIndex={2}
                    />
                    <Box
                      display={"flex"}
                      alignItems="center"
                      flexDir={"column"}
                    >
                      <VisualBuilderIcon />
                      <Text fontSize={"10px"} fontWeight={700} pt={2}>
                        VISUAL BUILDER
                      </Text>
                      <Text
                        color={"grays.12"}
                        fontSize="10px"
                        w={"146px"}
                        textAlign="center"
                        pt={1}
                      >
                        Design emails using drag and drop editor to create
                        engaging visual content without touching code
                      </Text>
                    </Box>
                  </Box>
                  <Box
                    position={"relative"}
                    borderWidth={"1px"}
                    w={"190px"}
                    h="159px"
                    ml={3}
                    borderRadius="4px"
                    gap="24px"
                    p="12px"
                    borderColor={"borders.100"}
                  >
                    <Radio
                      colorScheme={"primary"}
                      value="html_builder"
                      position={"absolute"}
                      top={4}
                      right={4}
                      zIndex={2}
                    />
                    <Box
                      display={"flex"}
                      alignItems="center"
                      flexDir={"column"}
                    >
                      <TextBuilderIcon />
                      <Text fontSize={"10px"} fontWeight={700} pt={1}>
                        TEXT/HTML BUILDER
                      </Text>
                      <Text
                        color={"grays.12"}
                        fontSize="10px"
                        w={"146px"}
                        textAlign="center"
                        pt={1}
                      >
                        Create emails faster and easier using a text/html
                        editor. No code required.
                      </Text>
                    </Box>
                  </Box>
                </HStack>
              </RadioGroup>
            </SimpleGrid>
          </Collapse>
          {/* <Collapse in={currentStageData?.data?.channel === "Email"}>
          <Box>
            <Text>Bodsquare Email Campaign Coming Soon...</Text>
            <Text>Stay tuned for updates</Text>
          </Box>
          </Collapse> */}
        </VStack>

        <Button
          isDisabled={
            !currentStageData?.data?.campaign_name ||
            !currentStageData?.data?.channel ||
            (currentStageData?.data.channel === "Email" &&
              !currentStageData?.data?.builder)
          }
          onClick={() => {
            setCurrentStageData((prevData) => {
              return {
                ...prevData,
                currentStage: "Templates",
              };
            });
          }}
          w="full"
          mt="40px"
          mb="10px"
          colorScheme={"primary"}
        >
          Continue to templates
        </Button>
      </Box>
    </Box>
  );
};

export default GettingStarted;
